<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">{{ $t("message.startTime") }}</label>
          <div class="col-sm-3">
            <el-date-picker v-model="detail.startTime" type="datetime" :placeholder="$t('message.startTime')" :picker-options="pickerOptions"> </el-date-picker>
          </div>
          <label class="col-sm-2 control-label">{{ $t("message.endTime") }}</label>
          <div class="col-sm-3">
            <el-date-picker v-model="detail.endTime" type="datetime" :placeholder="$t('message.startTime')" :picker-options="pickerOptionsEnd"> </el-date-picker>
          </div>
        </div>
        <div class="hr-line-dashed"></div>
        <div class="form-group">
          <div class="col-sm-12">
            <div class="pull-right">
              <div class="btn btn-primary" @click="submit()">{{ $t("message.Save") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";
import axios from "axios";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  data() {
    return {
      detail: {
        startTime: "",
        endTime: "",
      },
      pickerOptions: {
        disabledDate: this.disabledDueDate,
      },
      pickerOptionsEnd: {
        disabledDate: this.disabledDueDateEnd,
      },
    };
  },
  created: function () {
    this.init();
  },
  methods: {
    disabledDueDate(time) {
      return time.getTime() >= new Date(this.detail.endTime).getTime();
    },
    disabledDueDateEnd(time) {
      return time.getTime() < new Date(this.detail.startTime).getTime() - 24 * 60 * 60 * 1000;
    },
    async submit() {
      try {
        let vresult = await this.$validator.validate();
        if (!vresult) {
          this.fillInRequired();
          return;
        }
        let obj = this.getAuthObj;
        for (var key in this.detail) {
          obj[key] = this.detail[key];
        }
        obj.startTime = new Date(obj.startTime).getTime();
        obj.endTime = new Date(obj.endTime).getTime();
        if (obj.startTime > obj.endTime) {
          this.$message({
            message: this.$t("message.StartTimeLessThanEndTime"),
            type: "warning",
          });
          return;
        }
        var data = await this.$store.dispatch("saveSystemTheme", this.setFormData(obj));
        if (data.data.errorCode === 0) {
          this.$message({
            message: this.$t("message.SaveSuccess"),
            type: "success",
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async init() {
      try {
        let vresult = await this.$validator.validate();
        if (!vresult) {
          this.fillInRequired();
          return;
        }
        let obj = this.getAuthObj;
        for (var key in this.detail) {
          obj[key] = this.detail[key];
        }
        var data = await this.$store.dispatch("getSystemTheme", this.setFormData(obj));
        if (data.data.errorCode === 0 && data.data.result) {
          this.detail = data.data.result;
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
  mounted() {},
};
</script>
